import JsxHelper from '../../../Helpers/JsxHelper';
import TpJobItem from './TpJobItem';

export default class AllTpJobItem extends TpJobItem {
  static FieldsToShowInDataTable() {
    return [
      { label: 'Third Party Job ID', orderById: 'ThirdPartyJobId', data: TpJobItem.idFunction },
      {
        label: 'Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
      },
      {
        label: 'Project ID',
        orderById: 'ProjectId',
        data: 'ProjectId',
      },
      {
        label: 'Client Invoice ID',
        orderById: 'TpClientInvoiceId',
        data: 'TpClientInvoiceId',
      },
      {
        label: 'Location',
        orderById: 'ThirdPartyLocationName',
        data: 'ThirdPartyLocationName',
        minWidth: 50,
      },
      {
        label: 'Campaign',
        orderById: 'CampaignName',
        data: 'CampaignName',
        minWidth: 50,
      },
      {
        label: 'Fieldwork Office',
        orderById: 'FieldworkOfficeName',
        data: 'FieldworkOfficeName',
        minWidth: 50,
      },
      {
        label: 'Evaluator',
        orderById: 'TpEvaluatorFullName',
        data: 'TpEvaluatorFullName',
      },
      {
        label: 'Status',
        orderById: 'ThirdPartyJobStatus',
        data: TpJobItem.getStatusCellContent,
      },
      {
        label: 'Completed On',
        orderById: 'JobDate',
        data: 'JobDate',
      },
      {
        label: 'Country',
        orderById: 'ThirdPartyLocationCountry',
        data: 'ThirdPartyLocationCountry',
      },
      {
        label: 'Uninvoiceable',
        orderById: 'IsUninvoiceable',
        data: 'IsUninvoiceable',
      },
      {
        label: 'Paid Outside of System',
        orderById: 'PaidOutsideOfSystem',
        data: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem),
      },
    ];
  }
}
